export const PHONE_NO_REGEX = /^(\d|\+)[ \d-]+$/;
export const PERSONAL_NO_REGEX = /^\d{6,8}[-|(\s)]{0,1}\d{4}$/;
/**
 * A complete Swedish personal number (10 or 12 digits, dash or space optional) - the
 * shape oo-user-service accepts as a personal-number search keyword. Stricter than
 * PERSONAL_NO_REGEX (which validates form input).
 */
export const isCompletePersonalNumber = (term: string) =>
	/^(\d{6}|\d{8})[-\s]?\d{4}$/.test(term.trim());
export const ZIP_CODE_REGEX = /^\d{3}\s?\d{2}$/;
export const ORG_NO_REGEX = /^[0-9]+(-[0-9]+)+$/;
export const PASSWORD_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
